import { FiEdit } from "react-icons/fi";
import { FiTrash2 } from "react-icons/fi";
import { Link } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import Loading from "../../../Loading";
import axios from 'axios';
import { Get_SubjectCategory_ID } from './../../../../api/api';
import { toast } from 'react-toastify';
import { useEffect, useState } from "react";

const CategorySideBar = ({ data, refresh, setRefresh }) => {

     const [loading, setLoading] = useState(true);

     const deleteCategory = (id) => {
          confirmAlert({
               title: 'اخطار!',
               message: 'آیا از حذف این دسته بندی مطمئن هستید؟',
               buttons: [
                    {
                         label: 'بله',
                         onClick: async () => {
                              setLoading(true)
                              try {
                                   const res = await axios.delete(Get_SubjectCategory_ID(id))
                                   toast.success('با موفقیت انجام شد!')
                              } finally {
                                   setRefresh(true)
                              }
                         }
                    },
                    {
                         label: 'خیر',
                    }
               ]
          });
     }


     useEffect(() => {
          setLoading(true)
     }, [refresh])

     useEffect(() => {
          setLoading(false)
     }, [data])


     return (
          <>
               {loading || refresh ? <Loading styles='mini' /> : (
                    <>
                         {data ? data.map(cat => (
                              <li key={cat.id} id={cat.id}>
                                   <div className="catContainer">
                                        {cat.title}
                                        <div className="catOP">
                                             <Link className="editCat" to={`${cat.id}`}><FiEdit /></Link>
                                             <span className="removeCat" onClick={() => deleteCategory(cat.id)}><FiTrash2 /></span>
                                        </div>
                                   </div>
                                   {cat.child && (
                                        <ul>
                                             {cat.child.map(child => (
                                                  <li key={child.id} id={child.id}>
                                                       <div className="catContainer">
                                                            {child.title}
                                                            <div className="catOP">
                                                                 <Link className="editCat" to={`${child.id}`}><FiEdit /></Link>
                                                                 <span className="removeCat" onClick={() => deleteCategory(child.id)}><FiTrash2 /></span>
                                                            </div>
                                                       </div>
                                                  </li>
                                             ))}

                                        </ul>
                                   )}

                              </li>
                         )) : <Loading styles='mini' />}
                    </>
               )}
          </>
     )
}

export default CategorySideBar